/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventStatusEnum } from './EventStatusEnum';
import {
    EventStatusEnumFromJSON,
    EventStatusEnumFromJSONTyped,
    EventStatusEnumToJSON,
    EventStatusEnumToJSONTyped,
} from './EventStatusEnum';

/**
 * Emission Event serializer used for partial update operations.
 * @export
 * @interface EmissionEventPartialUpdate
 */
export interface EmissionEventPartialUpdate {
    /**
     * 
     * @type {number}
     * @memberof EmissionEventPartialUpdate
     */
    responsible?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmissionEventPartialUpdate
     */
    reviewer?: number | null;
    /**
     * 
     * @type {EventStatusEnum}
     * @memberof EmissionEventPartialUpdate
     */
    eventStatus: EventStatusEnum;
}



/**
 * Check if a given object implements the EmissionEventPartialUpdate interface.
 */
export function instanceOfEmissionEventPartialUpdate(value: object): value is EmissionEventPartialUpdate {
    if ((!('eventStatus' in (value as Record<string, any>)) && !('event_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['eventStatus'] === undefined && (value as Record<string, any>)['event_status'] === undefined)) return false;
    return true;
}

export function EmissionEventPartialUpdateFromJSON(json: any): EmissionEventPartialUpdate {
    return EmissionEventPartialUpdateFromJSONTyped(json, false);
}

export function EmissionEventPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionEventPartialUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'responsible': json['responsible'] === undefined ? undefined : json['responsible'] === null ? null : json['responsible'],
        'reviewer': json['reviewer'] === undefined ? undefined : json['reviewer'] === null ? null : json['reviewer'],
        'eventStatus': EventStatusEnumFromJSON(json['event_status']),
    };
}

export function EmissionEventPartialUpdateToJSON(json: any): EmissionEventPartialUpdate {
    return EmissionEventPartialUpdateToJSONTyped(json, false);
}

export function EmissionEventPartialUpdateToJSONTyped(value?: EmissionEventPartialUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'responsible': value['responsible'],
        'reviewer': value['reviewer'],
        'event_status': EventStatusEnumToJSON(value['eventStatus']),
    };
}

